import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (email: string, password: string) => {
    const params = new URLSearchParams();
    params.append('username', email);
    params.append('password', password);
    params.append('grant_type', 'password');
    params.append('client_id', 'employee');

    return apiClient.post('/api/admin/user/authenticate', params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  },
  checkAuth: () =>
    apiClient.get('/api/admin/user/check-authentication'),
  refreshToken: () =>
    apiClient.post('/api/admin/user/refresh-access-token'),
  logout: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
  },
};

export const watchesAPI = {
  getAll: (filterSettings?: any) => {
    if (filterSettings) {
      const queryString = new URLSearchParams(filterSettings).toString();
      return apiClient.get(`/api/watches?${queryString}`);
    }
    return apiClient.get('/api/watches');
  },
  getAllAdmin: (filterSettings?: any) => {
    if (filterSettings) {
      const queryString = new URLSearchParams(filterSettings).toString();
      return apiClient.get(`/api/admin/watches?${queryString}`);
    }
    return apiClient.get('/api/admin/watches');
  },
  getOne: (slug: string) => apiClient.get(`/api/watches/${slug}`),
  getWatch: (id: string) => apiClient.get(`/api/admin/watches/${id}`),
  getSale: (id: string) => apiClient.get(`/api/admin/watches/${id}/sale`),
  createWatch: (data: any) => apiClient.post('/api/admin/watches', data),
  updateWatch: (id: string, data: any) => apiClient.patch(`/api/admin/watches/${id}`, data),
  deleteWatch: (id: string) => apiClient.delete(`/api/admin/watches/${id}`),
  getTaxonomy: (id: string) => apiClient.get(`/api/admin/watches/${id}/taxonomy`),
  updateTaxonomy: (id: string, optionIds: string[]) =>
    apiClient.post(`/api/admin/watches/${id}/taxonomy`, { optionIds }),
  getImages: (id: string) => apiClient.get(`/api/admin/watches/${id}/images`),
  uploadImages: (id: string, formData: FormData) =>
    apiClient.post(`/api/admin/watches/${id}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  updateImage: (watchId: string, imageId: string, data: { altText?: string; displayOrder?: number }) =>
    apiClient.patch(`/api/admin/watches/${watchId}/images/${imageId}`, data),
  deleteImage: (watchId: string, imageId: string) =>
    apiClient.delete(`/api/admin/watches/${watchId}/images/${imageId}`),
  reorderImages: (id: string, imageOrders: Array<{ id: string; displayOrder: number }>) =>
    apiClient.patch(`/api/admin/watches/${id}/images/reorder`, { imageOrders }),
};

export const ordersAPI = {
  getAll: (params?: any) => {
    const query = params ? `?${new URLSearchParams(params).toString()}` : '';
    return apiClient.get(`/api/admin/orders${query}`);
  },
  getById: (id: string) => apiClient.get(`/api/admin/orders/${id}`),
  updateOrder: (id: string, data: any) => apiClient.patch(`/api/admin/orders/${id}`, data),
};

export const languagesAPI = {
  getAll: () => apiClient.get('/api/admin/languages'),
  getTranslations: (entityType: string, entityId: string) =>
    apiClient.get(`/api/admin/translations/${entityType}/${entityId}`),
  saveTranslations: (entityType: string, entityId: string, translations: any) =>
    apiClient.post(`/api/admin/translations/${entityType}/${entityId}`, { translations }),
};

export default apiClient;
